import { render, staticRenderFns } from "./btyy.vue?vue&type=template&id=626958b0&scoped=true"
import script from "./btyy.vue?vue&type=script&lang=js"
export * from "./btyy.vue?vue&type=script&lang=js"
import style0 from "./btyy.vue?vue&type=style&index=0&id=626958b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626958b0",
  null
  
)

export default component.exports